import { Component, Input, OnInit } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as GrantedAccessSelectors from '@states/granted-access/granted-access.selectors';
import { AppState } from '../../../../store/app.state';
import { Archive, ArchiveStatus, ArchiveVideoFormat } from '@models/archive.model';
import { GrantedAccessType } from '@enums/granted-access.enum';
import * as LocationModel from '../../../../locations/location.model';
import { StandaloneHlsPlayerModel } from '../../../../shared/video/standalone-hls-player/standalone-hls-player.model';
import { ArchiveService } from '../../../../development/archive.service';
import { GrantedAccessActions } from '@states/granted-access/granted-access.action-types';
import ArchiveDocument = Archive.ArchiveDocument;
import { ThumbnailsService } from '../../../../development/thumbnails.service';

@Component({
  selector: 'app-shared-archive',
  templateUrl: './shared-archive.component.html',
  styleUrls: ['./shared-archive.component.scss', '../shared-alert/shared-alert.component.scss'],
  standalone: false,
})
export class SharedArchiveComponent implements OnInit {

  public ArchiveVideoFormat = ArchiveVideoFormat;

  public timelineData: StandaloneHlsPlayerModel.TimelineData;
  public timelapseTimelineData: StandaloneHlsPlayerModel.TimelineData;

  @Input() sharedArchive: ArchiveDocument;
  @Input() archiveUrl: string;

  public selectSelectedLocation$: Observable<LocationModel.LocationModel.LocationItem> = this.store$.pipe(select(GrantedAccessSelectors.selectSelectedLocation));
  public selectAccessToken$: Observable<string> = this.store$.pipe(select(GrantedAccessSelectors.selectAccessToken));
  public selectIsRecordRemoved$: Observable<boolean> = this.store$.pipe(select(GrantedAccessSelectors.selectIsRecordRemoved));

  public grantedAccessTypes = GrantedAccessType;
  public archiveStatuses = ArchiveStatus;

  constructor(private store$: Store<AppState>, private archiveService: ArchiveService,
              private thumbnailsService: ThumbnailsService) {
  }


  private async getTimelineData(archive: ArchiveDocument): Promise<void> {
    // Parent already waits for the map, but keep this guard so getBucketBaseUrl is never raced.
    await lastValueFrom(this.thumbnailsService.whenPrivateStorageMapReady());
    this.timelineData = await lastValueFrom(this.archiveService.getArchiveTimeline(archive));
  }

  ngOnInit(): void {
    if (this.sharedArchive.videoFormat === ArchiveVideoFormat.TimelapseMP4) {
      void this.initTimelapseTimeline();
      return;
    }
    if (this.sharedArchive.videoFormat === ArchiveVideoFormat.HLS) {
      void this.getTimelineData(this.sharedArchive);
    }
    this.store$.dispatch(GrantedAccessActions.getCameraAudio({ edgeId: this.sharedArchive.edgeId, cameraId: this.sharedArchive.cameraId }));

  }

  private async initTimelapseTimeline(): Promise<void> {
    await lastValueFrom(this.thumbnailsService.whenPrivateStorageMapReady());
    const url = await lastValueFrom(this.archiveService.getTimelapseHlsPlaybackUrl(this.sharedArchive));
    this.timelapseTimelineData = {
      smartStorage: [],
      regularStorage: [
        {
          start: this.sharedArchive?.files?.videos[0]?.start,
          end: this.sharedArchive?.files?.videos[0]?.end,
          url,
        },
      ],
    };
  }

  public openMail() {
    window.open(`mailto:sales@lumana.ai`);
  }


}
